import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BoletimRightTabLI from './boletim_right_tab_LI';
import $ from 'jquery'


class BoletimRightTabData extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            tab: '',
            // paidata: [],
            tabShowData: {},
            entity_list_object: {},
            entityListUL: null
        }
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar */


    componentDidMount() {
        this.setstate()
    }


    componentDidUpdate(preProp) {
        if (this.props.date !== preProp.date) {
            this.setstate();
        }
    }


    setstate = () => {
        let tabShowData = this.props.tabShowData;
        if (!tabShowData['parcel']) {
            tabShowData['parcel'] = {}
        }
        if (tabShowData['parcel'] && !tabShowData['parcel'].titdireito)
            tabShowData['parcel'].titdireito = "";
        this.setState({
            tab: this.props.tab,
            // paidata: this.props.paidata,
            tabShowData: tabShowData
        });
       
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    

    getEntityNumDetail = (tab, data, entnum = null) => {
        let nif = null
        console.log(">>>>>>>>>>>>>>>>>>>>>>>%%%%%%%%%%%%%%%%%%%%%%%%%%%", data);
        if (entnum) {
            nif = entnum
            console.log("the entity line executed!!!!")
            // nif = parseInt(('' + nif).trim()) / 10
            nif = parseInt(('' + nif).trim())
            console.log("niffffffff is....", nif)
        }
        return (
            <ul className="list-unstyled mt-4">
                {
                    data && data.length > 0 ? data.map((_r,i)=> (
                        <BoletimRightTabLI
                            tab={tab}
                            key={i}
                            row={_r}
                            // nif={(('' + _r.entnum).trim()) / 10}
                            nif={(('' + _r.nif).trim())}
                            closePopup ={() => this.props.closePopup()}
                            date={new Date()}
                        />
                    ))
                        :
                        <BoletimRightTabLI
                            tab={tab}
                            nif={nif}
                            date={new Date()}
                        />
                }
            </ul>
        )
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        return (
            <div className="tab-content">
                {
                    this.props.tab === "boletimProprietario" &&
                    <div className="tab-pane container active">
                        {
                            this.state.tabShowData['boletimProprietario'] && this.state.tabShowData['boletimProprietario'].length > 0 ?
                            <>
                                {
                                    this.getEntityNumDetail('boletimProprietario', this.state.tabShowData['boletimProprietario'])
                                }
                                {
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <p className="ml-2">Nº de outros proprietários</p>
                                        </div>
                                        <h5>{this.props.outrosNoProperty || "0"}</h5>
                                    </div>
                                    
                                }
                                <div className="mt-3 mb-2 d-flex justify-content-center align-items-center">
                                    <div style={{borderRadius:"4px"}} data-toggle="modal" data-target='#left-popup' className="theme-color custom-btn cursor-pointer" onClick={() => this.props.edicaoRightTabData()}>Edição</div>
                                </div>

                            </>
                            :
                            <div className="searct-found">
                                <img className="img-fluid" src="imgs/search-large-icon.png" />
                                <p className="font-14">Sem proprietários</p>
                                <h5>Associe pelo menos um proprietário ao registo</h5>
                                <p className="mt-3">
                                    <span style={{borderRadius:"4px"}} data-toggle="modal" data-target='#left-popup' onClick={() => this.props.insertClickPopUp()} className="theme-color custom-btn cursor-pointer">+ Inserir</span>
                                </p>
                            </div>
                        }
                    </div>
                }
                {
                    (this.props.tab === "boletimExplorador") &&
                    <div className="tab-pane container active">
                        {
                            this.state.tabShowData['boletimExplorador'] && this.state.tabShowData['boletimExplorador'].length > 0 ?
                                <>
                                    {
                                        this.getEntityNumDetail('boletimExplorador', this.state.tabShowData['boletimExplorador'], this.state.tabShowData['boletimExplorador'][0].entnum)
                                    }
                                    {
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <p className="ml-2">Nº de outros exploradores</p>
                                            </div>
                                            <h5>{this.props.outrosNoExplorer || "0"}</h5>
                                        </div>
                                    }
                                    <div className="mt-3 mb-2 d-flex justify-content-center align-items-center">
                                        <div style={{borderRadius:"4px"}} data-toggle="modal" data-target='#left-popup' className="theme-color custom-btn cursor-pointer" onClick={() => this.props.edicaoRightTabData()}>Edição</div>
                                    </div>
                                </>
                                :
                                <div className="searct-found">
                                    <img className="img-fluid" src="imgs/search-large-icon.png" />
                                    <p className="font-14">Sem exploradores</p>
                                    <h5>Associe pelo menos um explorador ao registo</h5>
                                    <p className="mt-3">
                                        <span style={{borderRadius:"4px"}} data-toggle="modal" data-target='#left-popup' onClick={() => this.props.insertClickPopUp()} className="theme-color custom-btn cursor-pointer">+ Inserir</span>
                                    </p>
                                </div>
                        }
                    </div>
                }
            </div>
        )
    }
}


const mapStateToProps = ({ boletim }) => ({
    ...boletim
  });
  
  const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(BoletimRightTabData);